import { ArrowRightIcon, RightFillIcon } from "@t8891/icon";
import cx from "classnames";
import React, { Suspense, useEffect, useRef, useState } from "react";
import styles from "./Index.module.less";
import { Button, Checkbox, ConfigProvider, Pagination, Skeleton, Spin, Tooltip } from "antd";
import zhTW from "antd/es/locale/zh_TW";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import qs from "qs";
// import HotVideo from "@Components/movie/HotVideo/index";
import { article, host } from "@Api";
import { g4 } from "../../../utils/helper";
import KindCarItem from "../KindCarItem";
import { useSetState } from "ahooks";
import OverflowTooltip from "@Components/overflowTooltip";

const HotVideo = React.lazy(() => import("@Components/movie/HotVideo/index"));

const { fetchV3Articles } = article;

interface IProps {
  totalObj: {
    isEv: any;
    total: number;
    kindNum: number;
    modelNum: string;
  };
  brandsInfoMsg: {
    brandLogo: string;
    content: string;
    name: string;
  };
  salesValue: number;
  setSalesValue: (value: number) => void;
  dataSource: ICarListData[];
  loading: boolean;
  onChange: (e: any) => any;
}

export interface ICarListData {
  discountTitle: any;
  brandId: number;
  brandName: string;
  inquiry: number;
  kindId: number;
  kindName: string;
  maxDiscountPrice: string;
  modelNum: number;
  specLink: string;
  summaryLink: string;
  thumb: string;
  price: string;
  saleStop: number;
  equipMovieId: number;
  usedCarLink: string;
}

export enum ESalesType {
  /**
   * 停售
   */
  StopSales = 1,
  /**
   * 在售
   */
  Sales = 0,
}

const selectNav = [
  { label: "熱度", desc: "views-desc", asc: "views-asc" },
  { label: "價格", desc: "price-desc", asc: "price-asc" },
  { label: "續航", desc: "battery-life-desc", asc: "battery-life-asc" },
  { label: "油耗", desc: "oil-desc", asc: "oil-asc" },
];

let itemCss = {
  width: "302px",
  height: "170px",
  marginRight: "20px",
};

let { sales } = qs.parse(location.search, { ignoreQueryPrefix: true });

const List = React.memo((props: IProps) => {
  const { totalObj, dataSource, loading, brandsInfoMsg, onChange, salesValue, setSalesValue } = props;
  const [query, setQuery] = useSetState({
    discount: 0,
    sort: "views-desc",
    carFour: false,
    carEight: false,
    carTwelve: false,
    carSixteen: false,
    carTwenty: false,
  });
  const { discount, sort, carFour, carEight, carTwelve, carSixteen, carTwenty } = query;

  const [browsingListoryList, setBrowsingListoryList] = useState<ICarListData[]>([]);
  const [expand, setExpand] = useState<boolean>(false);

  const [moiveisData, setMoiveisData] = useState([]);
  const [sortSelectValue, setSortSelectValue] = useState<string>("views-desc");

  const brandObj = window.BRAND_INFO_DESCRIPTION;

  const sortValue = useRef<any[]>(["views-desc"]);
  const currentPage = useRef<number>(1);
  const themeColorStyle = useRef<any>({});

  const fetchMovies = async () => {
    try {
      const res: any = await fetchV3Articles({ type: 3, limit: 3, brandId: brandObj.brandId || 0 });
      if (res?.status === 12000) {
        res?.data?.list.map((item) => (item.views = ""));
        setMoiveisData(res?.data?.list || []);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (dataSource.length === 0) return;
    let carFour = dataSource.slice(0, 4).some((item) => !!item.discountTitle);
    let carEight = dataSource.slice(5, 8).some((item) => !!item.discountTitle);
    let carTwelve = dataSource.slice(9, 12).some((item) => !!item.discountTitle);
    let carSixteen = dataSource.slice(13, 16).some((item) => !!item.discountTitle);
    let carTwenty = dataSource.slice(17, 20).some((item) => !!item.discountTitle);

    setQuery({ carFour, carEight, carTwelve, carSixteen, carTwenty });
  }, [dataSource]);

  useEffect(() => {
    const browsingListoryList = localStorage.getItem("findCarBrowsingListoryList");
    if (browsingListoryList) {
      setBrowsingListoryList([...JSON.parse(browsingListoryList)]);
    }
    getThemeColorStyle();
    sales && setSalesValue(Number(sales));
    fetchMovies();
  }, []);

  const handleClickCheckbox = (item) => {
    const checked = item.target.checked;

    currentPage.current = 1;

    setQuery({
      discount: checked ? 1 : 0,
    });

    onChange({
      sort: sort,
      page: currentPage.current,
      discount: checked ? 1 : 0,
      saleStop: salesValue,
    });
  };
  const handleClickBox = (value) => {
    currentPage.current = 1;

    setQuery({
      sort: value,
    });

    setSortSelectValue(value);

    onChange({
      page: currentPage.current,
      sort: value,
      discount: discount,
      saleStop: salesValue,
    });
  };

  /**
   * 分页
   */
  const handleChangePagination = async (page, pageSize): Promise<any> => {
    currentPage.current = page;
    onChange({
      page: page,
      sort: sortSelectValue,
      saleStop: salesValue,
    });

    const element = document.getElementById("brand_msg");
    if (element) {
      const elementPosition = element.offsetTop;
      window.scrollTo({ top: elementPosition, behavior: "smooth" });
    }
  };
  const itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <Button>
          <a>
            <LeftOutlined />
            上一頁
          </a>
        </Button>
      );
    }
    if (type === "next") {
      return (
        <Button>
          <a>
            下一頁
            <RightOutlined />
          </a>
        </Button>
      );
    }
    if (type === "page") {
      return <a>{current}</a>;
    }
    return originalElement;
  };

  /**
   * 点击综述页
   */
  const handleClickSummary = (item) => {
    const index = browsingListoryList.findIndex((res: any) => res.kindId === item.kindId);
    const list: any = browsingListoryList || [];

    if (index !== -1) {
      list.splice(index, 1);
    }
    list.unshift(item);
    setBrowsingListoryList([...list]);
    localStorage.setItem("findCarBrowsingListoryList", JSON.stringify(list));
  };

  /**
   * 切换主题色
   */
  const getThemeColorStyle = async (): Promise<any> => {
    themeColorStyle.current = {
      color: "#fff",
      background: window.SEARCH_TYPE ? (window.SEARCH_TYPE === "default" ? "#3264ff" : "#1DBF76") : "#3264ff",
    };
  };

  /**
   * 切换在售，停售
   */
  const handleClickSales = (value) => {
    onChange({
      page: 1,
      sort: sortValue.current.join(","),
      saleStop: value,
    });
    setSalesValue(value);
  };

  const qrCodeContent = (
    <div className={styles["qr-code"]}>
      <p className={styles["code-text"]}>掃碼加入社群</p>
      <img
        src={"https://p3.8891.com.tw/nc/newcar/article/2021/01/19/1611044094465258.jpg"}
        alt=''
        className={styles["code-img"]}
      />
    </div>
  );

  return (
    <div className={styles["brand-box"]}>
      {brandsInfoMsg?.content !== "" && (
        <div className={styles["brand-msg"]}>
          <div className={styles["msg-top"]}>
            <div className={styles["top-box"]}>
              <img src={brandsInfoMsg?.brandLogo} alt='' className={styles["box-img"]} width={40} height={40} />
              <h1 className='text-22 font-medium text-[#333]'>{brandsInfoMsg?.name}</h1>
            </div>
            <Tooltip title={qrCodeContent} color={themeColorStyle.current.background}>
              <Button
                type='primary'
                className={styles["box-btn"]}
                style={{
                  backgroundColor: themeColorStyle.current.background,
                  borderColor: themeColorStyle.current.background,
                }}
              >
                加入社群
              </Button>
            </Tooltip>
          </div>
          <div className={styles["msg-bottom"]} onClick={() => setExpand(!expand)}>
            <div className={styles["bottom-text"]}>
              <span className={`flex-1 ${expand ? "line-clamp-6" : "line-clamp-2"}`}>{brandsInfoMsg?.content}</span>
              {brandsInfoMsg?.content.length > 160 && (
                <span
                  className={styles["bottom-btn"]}
                  style={{
                    color: themeColorStyle.current.background,
                  }}
                >
                  {expand ? " 收起" : " 展開"}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      <div className={styles["filter-container"]} id='brand_msg' style={{ marginTop: "20px" }}>
        <ul className={styles["filter-nav"]}>
          <li
            className={cx(styles["filter-nav_title"], { [styles["filter-nav_active"]]: salesValue == 0 })}
            onClick={() => handleClickSales(0)}
          >
            在售
            <i
              className={cx({ [styles["filter-nav-icon_active"]]: salesValue == 0 })}
              style={{ borderBottomColor: themeColorStyle.current.background }}
            ></i>
          </li>
          <li
            className={cx(styles["filter-nav_title"], { [styles["filter-nav_active"]]: salesValue == 1 })}
            onClick={() => handleClickSales(1)}
          >
            停售
            <i
              className={cx({ [styles["filter-nav-icon_active"]]: salesValue == 1 })}
              style={{ borderBottomColor: themeColorStyle.current.background }}
            ></i>
          </li>
        </ul>

        <div className={"flex gap-14 items-center"}>
          <p className='mt-2'>
            共<span className={styles["filter-number"]}>{totalObj.kindNum}</span>
            個車款，
            <span className={styles["filter-number"]}>{totalObj.modelNum || "0"}</span>
            個車型符合條件
          </p>
          <Checkbox
            value={"優惠車款"}
            checked={!!discount}
            className={cx(styles["checkbox-item"], {
              // [styles["theme-color-green"]]: window.SEARCH_TYPE === "ev",
            })}
            onChange={(res) => handleClickCheckbox(res)}
          >
            <span>優惠車款</span>
          </Checkbox>
          {selectNav.map(
            (res, index) =>
              ((!totalObj.isEv && res.label !== "續航") || (!!totalObj.isEv && res.label !== "油耗")) && (
                <div
                  className={`w-72 h-32 rounded-4 flex items-center text-14 ${[res.desc, res.asc].includes(sort) ? "text-primary" : "text-black"
                    } justify-center cursor-pointer`}
                  style={{ border: `1px solid ${[res.desc, res.asc].includes(sort) ? "#3264FF" : "#333"}` }}
                  key={index}
                  onClick={() => {
                    let value = sort.includes("desc") ? res.asc : res.desc;

                    if (![res.desc, res.asc].includes(sort)) {
                      value = res.desc;
                    }
                    handleClickBox(value);
                  }}
                >
                  {res.label}{" "}
                  {[res.desc, res.asc].includes(sort) ? (
                    <img
                      className='w-16 h-16'
                      style={{ transform: sort === res.asc ? "rotate(180deg)" : "rotate(0)" }}
                      src='https://photo.8891.com.tw/2024/10/14/1728887930915892.png'
                    />
                  ) : (
                    <img
                      className='w-16 h-16'
                      style={{ transform: sort === res.asc ? "rotate(180deg)" : "rotate(0)" }}
                      src='https://photo.8891.com.tw/2024/10/14/1728887931475138.png'
                    />
                  )}
                  {/* <ArrowToBottomIcon
                    className='-mt-2'
                    style={{ transform: sort === res.asc ? "rotate(180deg)" : "rotate(0)" }}
                    size={16}
                    fill={`${[res.desc, res.asc].includes(sort) ? "#3264FF" : "#333"}`}
                    strokeWidth={5}
                  /> */}
                </div>
              ),
          )}
        </div>
      </div>

      {dataSource.length > 0 ? (
        <>
          <div className={"mt-20 grid grid-cols-4 gap-24"}>
            {dataSource.map((item: any, index: number) => (
              <React.Fragment key={index}>
                {item.saleStop === 0 ? (
                  <KindCarItem
                    item={item}
                    visible={
                      index < 4
                        ? carFour
                        : index < 8
                          ? carEight
                          : index < 12
                            ? carTwelve
                            : index < 16
                              ? carSixteen
                              : carTwenty
                    }
                  />
                ) : (
                  <div className={cx(styles["list-item"])} key={item.kindId}>
                    {!!item.rightTips.content && (
                      <div
                        className='absolute right-6 top-0 h-20 flex items-center text-12 text-[#999] z-1 py-10'
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          if (!!item.rightTips.link) {
                            window.open(item.rightTips.link, "_blank");
                          }
                        }}
                      >
                        {item.rightTips.content}
                        <ArrowRightIcon className='relative -top-1' size={24} />
                      </div>
                    )}
                    <a
                      href={item.summaryLink}
                      target='_blank'
                      className={styles["item-msg"]}
                      onClick={() => handleClickSummary(item)}
                    >
                      <img src={item.thumb} className={styles["item-img"]} alt={`${item.brandName} ${item.kindName}`} />

                      <OverflowTooltip tooltipTitle={`${item.brandName} ${item.kindName}`}>
                        <h2 className={styles["item-brand"]}>{`${item.brandName} ${item.kindName}`}</h2>
                      </OverflowTooltip>

                      {
                        //0是正常, 1是停售
                        !item.saleStop ? (
                          <>
                            <h3 className={styles["item-price"]}>{item.price}</h3>
                            <p className={styles["item-results"]}>
                              共{item.modelNum}
                              台符合條件車型
                            </p>
                          </>
                        ) : (
                          <p className={styles["item-stop"]}>停售</p>
                        )
                      }
                    </a>
                    <div className={styles["item-btn"]}>
                      {item.inquiry !== 0 && (
                        <a
                          href={`${host.c}/ask/price?b=${item.brandId}&k=${item.kindId}&source=${window.dynx_itemid ? "車款" : "廠牌"
                            }找車-熱門詢價`}
                          target='_blank'
                          className={styles["btn-ask"]}
                        >
                          一鍵詢價
                        </a>
                      )}
                      {(item.saleStop === 1 || (item.saleStop === 0 && item.inquiry === 0)) &&
                        item.usedCarLink !== "" && (
                          <a
                            href={item.usedCarLink}
                            target='_blank'
                            className={cx(styles["btn-ask"], styles["used-car"])}
                          >
                            中古車
                          </a>
                        )}

                      {item.equipMovieId && item.equipMovieId !== 0 ? (
                        <a href={`${host.c}/equip/shorts/${item.equipMovieId}`} className={styles["btn-config"]}>
                          <span className={styles["btn-icon"]}>
                            <RightFillIcon size={12} fill={"#333333"} />
                          </span>
                          配備詳解
                        </a>
                      ) : (
                        item.specLink && (
                          <a href={item.specLink} className={styles["btn-config"]}>
                            配備
                          </a>
                        )
                      )}
                    </div>
                    {item.maxDiscountPrice !== "" && (
                      <div className={styles["item-bag"]}>
                        <p className={styles["bag-title"]}>最高優惠</p>
                        <p className={styles["bag-price"]}>禮包{item.maxDiscountPrice}</p>
                      </div>
                    )}
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className={styles["pagination"]}>
            <ConfigProvider locale={zhTW}>
              <Pagination
                defaultCurrent={1}
                total={totalObj.total}
                itemRender={itemRender}
                pageSize={20}
                showQuickJumper={{
                  goButton: (
                    <Button
                      className={cx(styles["pagination-btn"])}
                      style={{
                        background: themeColorStyle.current.background,
                      }}
                    >
                      確定
                    </Button>
                  ),
                }}
                className={cx({
                  [styles["theme-color-green"]]: window.SEARCH_TYPE === "ev",
                })}
                showSizeChanger={false}
                current={currentPage.current}
                hideOnSinglePage
                onChange={handleChangePagination}
              />
            </ConfigProvider>
          </div>
        </>
      ) : (
        <Spin spinning={loading}>
          <div className={styles["no-data"]}></div>
        </Spin>
      )}


      {totalObj.total === 0 && !loading && (
        <div className={styles["no-data"]}>
          <img src={"https://photo.8891.com.tw/2024/12/17/1734403805110372.png"} className={styles["no-data-img"]} />
          <span className={styles["no-data-test"]}>未能找到合適車型</span>
        </div>
      )}


      {window.PAGE_NAME === "modelKind" && !!moiveisData.length && (
        <section className={styles["news-video-box"]}>
          <Suspense fallback={<Skeleton style={{ height: 250 }} />}>
            <HotVideo
              itemCss={itemCss}
              iconCss={{ top: "88px" }}
              titleCss={{ marginBottom: "18px", fontSize: "20px" }}
              boxCss={{ marginBottom: "0" }}
              itemTitleLineClamp={1}
              scrollToNum={665}
              dataSource={{
                title: `${brandObj?.brandEnName || ""}相關影音`,
                movies: moiveisData,
              }}
              moreHref={`${host.www}/index-search.html?keyword=${brandObj?.brandUrlName}&tab=movie`}
              likeIconShow={false}
              type={2}
              maxLength={3}
              isShowScroll={false}
              urlParams={"?spm=3.73.90.110"}
              onClick={(data) => {
                g4("video_clicked", {
                  page: "找車頁",
                  spm: "",
                  channel: "新車",
                  module: "列表",
                  element: "廠牌相關影音",
                  element_id: "影音",
                  object_type: "",
                  object_id: data.id,
                  sub_module: "",
                  next_spm: "3.73.90.110",
                });
              }}
              onExposured={(data) => {
                g4("video_exposured", {
                  page: "廠牌找車頁",
                  spm: "",
                  channel: "新車",
                  module: "列表",
                  element: "廠牌相關影音",
                  element_id: "影音",
                  object_type: "",
                  object_id: data.id,
                  sub_module: "",
                  next_spm: "3.73.90.110",
                });
              }}
            />
          </Suspense>
        </section>
      )}
    </div>
  );
});

export default List;
